import * as React from 'react';
import { SVGProps } from 'react';
import { withForgeIconProps } from './ForgeIconProps';
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgExpandLarge = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps): JSX.Element => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="fi_c_icon"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M23 6.60498L11.89 17.605L1 6.60498"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SvgExpandLarge.displayName = 'SvgExpandLarge';
const ExpandLarge = withForgeIconProps(SvgExpandLarge, {
  name: 'Expand',
  usage: 'Use to expand an Accordion or a dropdown.',
  related: 'open',
  isLabelRequired: false,
  isNeutralInteractive: true,
  size: 'large',
});
export default ExpandLarge;
